import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const { lang } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error(lang === "tr" ? "Şifreler eşleşmiyor" : "Passwords do not match");
      return;
    }
    if (password.length < 6) {
      toast.error(lang === "tr" ? "Şifre en az 6 karakter olmalı" : "Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(lang === "tr" ? "Şifre güncellendi" : "Password updated");
      navigate("/login");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Error");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="px-6 py-20 max-w-md mx-auto text-center">
        <p className="text-sm text-[#EF4444]">{lang === "tr" ? "Geçersiz bağlantı" : "Invalid link"}</p>
        <Link to="/forgot-password" className="text-[#C8A96A] underline mt-4 inline-block">{lang === "tr" ? "Tekrar dene" : "Try again"}</Link>
      </div>
    );
  }

  return (
    <div data-testid="reset-password-page" className="px-6 py-20 max-w-md mx-auto">
      <h1 className="font-heading text-4xl mb-2 text-center">{lang === "tr" ? "Yeni Şifre" : "New Password"}</h1>
      <p className="text-xs uppercase tracking-[0.2em] text-center text-[#C8A96A] mb-10">Uzungöl Kuyumculuk</p>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="block text-[10px] uppercase tracking-[0.2em] mb-2">{lang === "tr" ? "Yeni Şifre" : "New Password"}</label>
          <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full border-b border-[#0A0A0A] bg-transparent py-2 text-sm focus:outline-none focus:border-[#C8A96A]" />
        </div>
        <div>
          <label className="block text-[10px] uppercase tracking-[0.2em] mb-2">{lang === "tr" ? "Şifreyi Onayla" : "Confirm Password"}</label>
          <input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
            className="w-full border-b border-[#0A0A0A] bg-transparent py-2 text-sm focus:outline-none focus:border-[#C8A96A]" />
        </div>
        <button data-testid="reset-submit" disabled={loading} className="w-full bg-[#0A0A0A] hover:bg-[#C8A96A] text-white py-4 text-xs uppercase tracking-[0.25em] transition-colors disabled:opacity-50">
          {loading ? "..." : (lang === "tr" ? "Şifreyi Güncelle" : "Update Password")}
        </button>
      </form>
    </div>
  );
}
